import BreadcrumbRequestValueObject from './BreadcrumbRequestValueObject.js'
import {BreadcrumbUrlBuilderRequestValueObject} from './BreadcrumbUrlBuilderRequestValueObject'
import BreadcrumbValueObject from './BreadcrumbValueObject.js'

export default class BreadcrumbValueObjectsFactory {
  static breadcrumbValueObject = ({breadcrumbs}) => new BreadcrumbValueObject({breadcrumbs})

  static breadcrumbRequestValueObject = ({
    offerTypeId,
    category1Id,
    category2Id,
    bodyTypeId,
    makeId,
    modelId,
    provinceId,
    version
  }) =>
    new BreadcrumbRequestValueObject({
      offerTypeId,
      category1Id,
      category2Id,
      bodyTypeId,
      makeId,
      modelId,
      provinceId,
      version
    })

  static breadcrumbUrlBuilderRequestValueObject = ({items}) => new BreadcrumbUrlBuilderRequestValueObject({items})
}
